import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'arivo-google-sign-in-button',
  templateUrl: './arivo-google-sign-in-button.component.html',
  styleUrl: './arivo-google-sign-in-button.component.scss',
})
export class ArivoGoogleSignInButtonComponent {
  @Input() label = 'Sign in with Google';
  @Input() disabled = false;
  @Output() buttonClick = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled) {
      this.buttonClick.emit();
    }
  }
}
